import { useEffect, useState } from "react";
import { getAwards } from "../../utils/API";


const Awards = () => {

    const [awardsData, setAwardsData] = useState<any>([]);

    useEffect(() => {
        const AwardsData = async () => {
            try {
                const response = await getAwards();
                if (response.data.awards && response.data.awards.length > 0) {
                    setAwardsData(response.data.awards);
                }
            } catch (error) {
                console.error("Error fetching setting data:", error);
            }
        };

        AwardsData();
    }, []);

    return (
        <>
            <nav className="bg-gray-100 p-4 shadow-md m-5">
                <div className="container mx-auto flex justify-between items-center">
                    <h4 className="text-black font-bold ml-4 sm:ml-10 lg:ml-20">
                        AWARDS AND ACCOLADES
                    </h4>
                    <ul className="flex space-x-4 md:mr-10 lg:mr-20">
                        <li className="text-gray-500 text-sm">HOME</li>
                        <li className="text-gray-500 text-sm">AWARDS AND ACCOLADES</li>
                    </ul>
                </div>
            </nav>

            <div className="p-10">
                <h2 className="mb-8 text-3xl text-orange-500 ml-4 sm:ml-10 lg:ml-12 font-bold">
                    Awards and Accolades
                </h2>
            </div>

            <div className="container mx-auto p-4 px-4 sm:px-10 lg:px-20">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-x-4 gap-y-6">

                    {awardsData && awardsData.map(((award: any) => (
                        <div className="bg-gray-100 flex flex-col items-center relative">
                            <img src={`${process.env.REACT_APP_Image_URL}/awards/${award.file}`} className="w-4/6 relative" style={{ height: "400px !important" }} />
                            <h1 className="text-center w-full bg-orange-500 text-white text-sm sm:text-base p-2 sm:p-3">
                                {award.title}
                            </h1>
                        </div>
                    )))}


                </div>
            </div>
        </>
    );

}


export default Awards;